<template>
  <div style="height: 100%;">
    <BaseContainer style="height: 100%" class="one_table">
      <TableMain name="one table" ref="VendTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" :table_height_adjust="-8"
        :hb_table_class="'hb_table_vend_class1'" :loading_width="70" @on_query="on_query"
        :show_toolbar_button="[0, 0, 0, 0, 0]">
        <template #query>
          {{ $t("common.company") }}：
          <el-select v-model="dataAreaId" filterable clearable :placeholder="$t('common.company')" style="width: 120px">
            <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
              :label="item.DataArea" :value="item.DataArea"></el-option>
          </el-select>
          {{ $t("common.provider") + $t("common.account") }}：<el-input clearable size="small" style="width: 150px"
            v-model="AccountNum"></el-input>
          {{ $t("common.provider") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
            v-model="SEI_Name"></el-input>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as VendTableController from "../../controllers/base/VendTableController"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"

export default {
  name: "VendTable",
  components: {
    BaseContainer,
    TableMain,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_vend",
      },
      fields: VendTableController.fields.detail_fields,
      AccountNum: "",
      dataAreaId: "",
      SEI_Name: "",
      isBusy: false,
    }
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      if (_.isNull(date_range)) {
        this.msgModal(this.$t("notify.wait_too_long")).then(
          async (value) => {
            if (value) {
              await this.excuteQuery(set_data, date_range)
            }
            else {
              this.isBusy = false
              set_data([])
            }
          }
        )
      } else {
        await this.excuteQuery(set_data, date_range)
      }
    },
    async excuteQuery(set_data, date_range) {
      let _fromDate = "",
        _toDate = ""
      let _params = { id: { ">": 0 } }
      if (this.AccountNum != "") {
        _params.AccountNum = { like: "%" + this.AccountNum + "%" }
      }
      if (this.SEI_Name != "") {
        _params.SEI_Name = { like: "%" + this.SEI_Name + "%" }
      }
      if (this.dataAreaId != "") {
        _params.dataAreaId = { "=": this.dataAreaId }
      }
      if (
        !_.isNull(date_range) &&
        this.AccountNum == "" &&
        this.dataAreaId == "" &&
        this.SEI_Name == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["SEI_modifiedDateTime"] = { ">=": _fromDate, "<=": _toDate }
      }
      set_data([])
      let _result = await VendTableController.methods.getItemData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["SEI_modifiedDateTime"], ["desc"]))
      }
      this.isBusy = false
    },
    //#endregion

    current_changed(old, current) {

    },
  },
}
</script>
<style>
.hb_table_vend_class1 {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 150rem;
}
</style>
